import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProductGroup } from "./UseProductGroup";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress, rsParentChilds, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CustomPagination from "../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ProductGroupsChilds from "./ProductGroupsChilds";
import useBreakpoints from "../../hooks/useBreakpoints";

function ProductGroup(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const { getGroupList, deleteGroup } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [PageScrollTo, setPageScrollTo] = useState(
    location.state && location.state.scrollTo
      ? location.state.scrollTo
      : undefined
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [searchToShow, setSearchToShow] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getGroupList(
      searchToShow,
      (productgroups) => {
        setProgress(false);
        setFiltered(productgroups.productGroups);
      },
      true
    );
  }, [searchToShow]);

  const newFunc = () => {
    setParentID({
      id: null,
      name: "",
      scrolParent: { top: 0, left: 0 },
    });
    return navigate("/productgroups/addproductGroup", {
      state: {
        search: searchToShow,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 220,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "توضیحات",
      width: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.description ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 120,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/productgroups/editproductgroup", {
                    state: {
                      model: cellValues.row,
                      id: cellValues.row.id,
                      scrollTo: cellValues.api.getScrollPosition(),
                      search: searchToShow,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Childs">
              <IconButton
                onClick={() => {
                  setParentID({
                    id: cellValues.row.id,
                    name: cellValues.row.faName,
                    scrolParent: cellValues.api.getScrollPosition(),
                  });
                }}
              >
                <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productgroups" }],
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={3}
        sx={{ height: "90% !important" }}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <TextField
            placeholder="جستجو گروه"
            size="small"
            sx={{ mb: 2 }}
            variant="outlined"
            value={searchState}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              if (evt.target.value == "") {
                setSearchToShow("");
              }
              setSearchState(evt.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setParentID({
                  id: null,
                  name: "",
                  scrolParent: { top: 0, left: 0 },
                });
                setSearchToShow(searchState);
              }
            }}
          />
          <DataGrid
            // className="ltr-grid"
            disableVirtualization
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "&  .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "&  .MuiDataGrid-cell:focus-within ": {
                outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
              },
              "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !Important",
              },
              "& .MuiDataGrid-cell:hover": {
                color: "primary.main",
              },
              "& .MuiDataGrid-virtualScrollerRenderZone": {
                width: "100% !important",
              },
              "& .primary": {
                width: "100%",
                backgroundColor: "#ECF6E7 !important",
              },
              "& .none": {
                width: "100%",
                backgroundColor: "#fff !important",
              },
            }}
            columns={columns}
            rows={filtered ? filtered : []}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                scrollTo: PageScrollTo,
                nofab: true,
                isLtr: true,

                newGroup: props.ProductGroup ? false : newFunc,
              },
            }}
            getRowClassName={(params) => {
              if (params.row.id == parentID.id) {
                return "primary";
              }
              if (params.row.id !== parentID.id) {
                return "none";
              }
            }}
          />
        </Box>
        <Box
          sx={{ mt: isSmall ? 7 : 0 }}
          gridColumn={isSmall ? "span 12" : "span 6"}
        >
          <ProductGroupsChilds
            searchToShow={searchToShow}
            setSearchToShow={setSearchToShow}
            PageScrollTo={PageScrollTo}
            setPageScrollTo={setPageScrollTo}
          />
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"گروه"}
        callback={() => {
          setProgress(true);
          deleteGroup(deleteState.id, () => {
            getGroupList(
              searchToShow,
              (productgroups) => {
                setFiltered(productgroups.productGroups);
              },
              true
            );
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}

export default ProductGroup;
